export default __webpack_public_path__ + "static/media/caret-down-outline.bd26a010.svg";